// UK numbers the way staff read and say them: +447935877544 → "07935 877544",
// +442037104705 → "020 3710 4705". Display only: dial, search and save the raw
// value. Anything that isn't a UK number (or isn't a number) comes back unchanged.

const groups = (digits, sizes) => {
  const out = [];
  let at = 0;
  sizes.forEach((size) => { out.push(digits.slice(at, at + size)); at += size; });
  return out.filter(Boolean).join(' ');
};

// Ofcom groupings: mobiles 5+6, London-style 02x 3+4+4, 011x / 01x1 cities 4+3+4,
// other geographic 5+6 (5+5 for the short ones), 03/08/09 4+3+4 (0800 4+6 when short).
function groupNational(n) {
  if (n.length === 11) {
    if (n.startsWith('07')) return groups(n, [5, 6]);
    if (n.startsWith('02')) return groups(n, [3, 4, 4]);
    if (/^01(1\d|\d1)/.test(n)) return groups(n, [4, 3, 4]);
    if (n.startsWith('01')) return groups(n, [5, 6]);
    if (/^0[389]/.test(n)) return groups(n, [4, 3, 4]);
    return null;
  }
  if (n.length === 10) {
    if (n.startsWith('01')) return groups(n, [5, 5]);
    if (n.startsWith('0800')) return groups(n, [4, 6]);
  }
  return null;
}

export function formatUkPhone(value) {
  if (typeof value !== 'string') return value;
  const trimmed = value.trim();
  // Only plain phone characters: "Unknown", "Withheld" and names pass through.
  if (!/^\+?[\d\s()-]+$/.test(trimmed)) return value;
  const digits = trimmed.replace(/\D/g, '');
  let national = null;
  let international = '';
  if (trimmed.startsWith('+')) international = digits.startsWith('44') ? digits.slice(2) : '';
  else if (digits.startsWith('0044')) international = digits.slice(4);
  else if (digits.startsWith('44') && digits.length === 12) international = digits.slice(2);
  // "+44 (0)20 …" carries the trunk 0 inside the international form.
  if (international) national = `0${international.replace(/^0/, '')}`;
  else if (digits.startsWith('0') && !digits.startsWith('00')) national = digits;
  if (!national) return value;
  return groupNational(national) || value;
}

export default formatUkPhone;
